import Vue from 'vue';
import ModalBox from './modal-box';
const Instance = new Vue({
  render: h => h(ModalBox),
});

const component = Instance.$mount();
// document.body.appendChild(component.$el);
const instance = Instance.$children[0];

export default instance;
